/* import __COLOCATED_TEMPLATE__ from './renderable-starting-guide-blocks-value.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();